import { render, staticRenderFns } from "./AddPurchaseOffers.vue?vue&type=template&id=38a46199&"
import script from "./AddPurchaseOffers.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports